import React, { useState, useEffect } from "react";
import { Table, Button, Popconfirm, Space } from "antd";
import getIconByName from "../../../components/getIconByName";
import validarpermiso from "../../../lib/utils";

const MenuTable = ({
  menus,
  loading,
  pagination,
  handleTableChange,
  showModal,
  handleDelete,
  permisos
}) => {
  const [icons, setIcons] = useState(null);

  useEffect(() => {
    // Dynamic import of Material Icons
    import("@mui/icons-material").then((importedIcons) => {
      setIcons(importedIcons);
    });
  }, []);

  const renderMaterialIcon = (iconName) => {
    if (!iconName) return "N/A";
    
    if (icons) {
      const IconComponent = icons[iconName];
      
      if (IconComponent) {
        return (
          <IconComponent
            style={{ fontSize: "24px", color: "#00b96b", width: 20 }}
          />
        );
      }
    }
    
    if (iconName === "move_group") {
      return "N/A";
    }
    
    return getIconByName(iconName);
  };

  const getChildrenLabels = (childrenIds, menus) => {

    return childrenIds
      .map((id) => {
        const menu = menus.find((m) => m.id === id);
        console.log("menu",menus);
        
        return  menu.label;
      })
      .join(", ");
  };

  const transformedMenus = menus.map((menu) => ({
    ...menu,
    childItems: menu.children,
    children: undefined,
  }));


  const columns = [
    {
      title: "Nombre",
      dataIndex: "label",
      key: "label",
    },
    {
      title: "Ícono",
      dataIndex: "iconv",
      key: "iconv",
      width: 80, // Ancho fijo para la columna
      render: (iconv) => renderMaterialIcon(iconv),
    },
    {
      title: "Es Padre",
      dataIndex: "espadre",
      key: "espadre",
      render: (espadre) => (espadre ? "Sí" : "No"),
    },
    {
      title: "Slug",
      dataIndex: "slug",
      key: "slug",
    },

    {
      title: "Fecha de Creación",
      dataIndex: "date_created",
      key: "date_created",
      render: (date) => new Date(date).toLocaleString(),
    },
    {
      title: "Acciones",
      key: "actions",
      render: (_, record) => (
        <Space>
          {validarpermiso("menu", "update", permisos) && (
            <Button 
              type="primary" 
              onClick={() => showModal(record)}
            >
              Editar
            </Button>
          )}
          {validarpermiso("menu", "delete", permisos) && (
            <Popconfirm
              title="¿Estás seguro de eliminar este menú?"
              onConfirm={() => handleDelete(record.id)}
              okText="Sí"
              cancelText="No"
            >
              <Button type="primary" danger>
                Eliminar
              </Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Table
    
      dataSource={transformedMenus}
      columns={columns}
      rowKey="id"
      loading={loading}
      pagination={pagination}
      onChange={handleTableChange}
      expandable={{
        expandedRowRender: (record) => (
          <p style={{ margin: 0 }}>
            <strong>Menús Hijos:</strong>{" "}
            {getChildrenLabels(record.childItems || [], menus)}
          </p>
        ),
        rowExpandable: (record) => record.espadre && validarpermiso("menu", "read", permisos),
      }}
    />
  );
};

export default MenuTable;
